module.exports = __webpack_public_path__ + "static/media/15.31798acf.png";